import { Navigate } from "react-router-dom";
import { getSessionData } from "../../utils/helper";
import { envMapping, roleMapping } from '../../utils/constants'

const ProtectedRouteAuditLog = ({ children }: { children: JSX.Element }) => {
  const isLocalDevelopment = process.env.REACT_APP_LOCAL_DEVELOPMENT === 'true';

  // In local development mode, bypass authorization check
  if (isLocalDevelopment) {
    return children;
  }

  const userInfo = getSessionData();
  const userEnvGroups: string[] = userInfo?.envGroups || [];
  const userRole: string= userInfo?.role;

  const hostname = window.location.hostname;
  const requiredEnv = envMapping[hostname];
  const requiredRole= roleMapping[hostname]

  if (!requiredEnv || !userEnvGroups.includes(requiredEnv) || !userRole.includes(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRouteAuditLog;
